import { Info } from '@dreamstack/icons/src/icon-components/Info'
import { cn } from '@dreamstack/util/src/cn'
import Tippy from '@tippyjs/react'
import React, { useEffect, useRef, useState } from 'react'
import 'tippy.js/dist/tippy.css'
import './LtvIconArrow.css'

const StyledInfoIcon: React.FC<{ $isActive?: boolean }> = ({ $isActive }) => (
  <Info
    className={cn(
      'h-px-32 w-px-32 cursor-pointer select-none my-px-8',
      $isActive
        ? 'text-accentroGray-full ease-linear duration-200'
        : 'text-accentroGray-400'
    )}
  />
)

const StyledTippyPopover: React.FC<React.ComponentProps<typeof Tippy>> = ({
  className,
  ...rest
}) => (
  <Tippy
    className={cn(
      'bg-accentroGray-full rounded-none p-px-12 text-accentroWhite-full text-px-13 leading-px-18',
      'md:min-w-[550px] md:text-px-16 md:leading-px-24 md:p-px-32',
      'ml:min-w-[600px]',
      className
    )}
    {...rest}
  />
)

export const LtvInfoIcon: React.FC = () => {
  const referenceRef = useRef<HTMLDivElement | null>(null)
  const [openState, setOpenState] = useState(false)

  const handleClickOutside = (event: any) => {
    if (referenceRef.current && !referenceRef.current.contains(event.target)) {
      event.stopPropagation()
    }
  }
  const onHover = (action: 'onMouseEnter' | 'onMouseLeave') => {
    if (action === 'onMouseEnter') setOpenState(true)
    if (action === 'onMouseLeave') setOpenState(false)
  }

  useEffect(() => {
    document.addEventListener('mousedown_', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown_', handleClickOutside)
    }
  })

  return (
    <StyledTippyPopover
      popperOptions={{ modifiers: [{ name: 'flip', enabled: false }] }}
      interactive={true}
      content="Purchase contracts in Germany must be signed in the presence of a notary, who also records the property sale in the land registry. The overall cost of this service is usually around 1.5% of the purchasing price. This will involve an approximately 1% invoice paid directly to the notary office after signing contracts; and approximately 0.5% spread over three separate invoices during the land registry process – removing the old name and entering you as the registered owner."
    >
      <div
        ref={referenceRef}
        onMouseEnter={() => onHover('onMouseEnter')}
        onMouseLeave={() => onHover('onMouseLeave')}
      >
        <StyledInfoIcon $isActive={openState} />
      </div>
    </StyledTippyPopover>
  )
}
